export interface ErrorDisplayProps {
  error: string
}

export function ErrorDisplay({ error }: ErrorDisplayProps) {
  return (
    <div className="mt-4 p-4 border-red-500 bg-red-50 rounded-md">
      <span className="font-semibold text-red-900">Error: </span>
      <span className="text-sm text-red-700 mt-1">{error}</span>
    </div>
  )
}
